import { Locale } from 'date-fns';

import { get, post } from '@eika-infrastruktur/request';

import { ConversionRequest, ConversionResult, CurrencyDetails, ExchangeRateResult } from '@generated-types';

interface RequestHeaders {
    headers: {
        [k: string]: string;
    };
}
const getRequestHeaders = (): RequestHeaders => ({
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-By': 'kredittkort-js-client',
    },
});

const RESOURCE_PATH = '/kredittbank-kredittkort-betjening-web/rest/resource';

const BASE_PATH = 'v4/visa/exchange';

export const getAvailableCurrencies = (locale?: Locale): Promise<CurrencyDetails[]> => {
    const query = locale ? `?locale=${locale}` : '';
    const url = `${RESOURCE_PATH}/${BASE_PATH}/currencies${query}`;

    return get(url, getRequestHeaders());
};

const getRate = (from: string, to: string, rateAt?: string): Promise<ExchangeRateResult> => {
    const rateAtQuery = rateAt ? `&rateAt=${rateAt}` : '';
    const query = `from=${from}&to=${to}${rateAtQuery}`;

    const url = `${RESOURCE_PATH}/${BASE_PATH}/rate?${query}`;

    return get(url, getRequestHeaders());
};

export const getRateBothWays = (
    currencyCode1: string,
    currencyCode2: string,
    rateAt?: string,
): Promise<ExchangeRateResult[]> =>
    Promise.all([getRate(currencyCode1, currencyCode2, rateAt), getRate(currencyCode2, currencyCode1, rateAt)]);

export const getDetailedMarkup = (
    amount: number,
    fromCurrency: CurrencyDetails,
    toCurrency: CurrencyDetails,
): Promise<ConversionResult> => {
    const body: ConversionRequest = {
        sourceAmount: {
            amount,
            currency: fromCurrency.currencyCode,
        },
        destinationCurrency: toCurrency.currencyCode,
    };

    const url = `${RESOURCE_PATH}/${BASE_PATH}`;

    return post<ConversionResult>(url, body, getRequestHeaders());
};
